import axios from 'axios'
import env from '../env'

export default class BoxFeeAPI {
  /** 获取门店打包费 */
  static getStoreOrdersBoxFee (params: any) {
    return axios.get(`${env.JMOBILE}/boxFee/getStoreOrdersBoxFee`, { params }).then((res: any) => {
      if (res?.result) {
        return res.result
      }
      throw res
    })
  }
}
